import { render } from "./AddEditFormRecord.vue?vue&type=template&id=7271388c&scoped=true"
import script from "./AddEditFormRecord.vue?vue&type=script&lang=js"
export * from "./AddEditFormRecord.vue?vue&type=script&lang=js"

import "./AddEditFormRecord.vue?vue&type=style&index=0&id=7271388c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7271388c"]])

export default __exports__